import React, { useState } from 'react'
import sidebarStyle from './SideBar.module.css'
import profile from '../../../assets/images/brandlogo.png'
import { Link, useLocation } from 'react-router-dom';
import { MdDashboard } from "react-icons/md";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { FaHeart } from "react-icons/fa6";
import { IoIosPaper } from "react-icons/io";
import { HiSpeakerWave } from "react-icons/hi2";
import { IoBook } from "react-icons/io5";
import { ImUser } from "react-icons/im";
import { BiLogOut } from "react-icons/bi";
import DashboardPage from "../../pages/dashboard/DashboardPage";
import UserProfilePage from "../../pages/userprofile/UserProfilePage";
import AddEventPage from "../../pages/addevent/AddEventPage";
import CoordinatorDashboardPage from "../../pages/coordinatordashboard/CoordinatorDashboardPage";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutCoordinator } from '../../../redux/slices/coordinatorSlices';
import Swal from "sweetalert2";

export default function SideBar(props) {
  const coordinator = useSelector((state) => state.coordinator);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const BASE_URL = 'https://www.authormeet.net/authormeetapi/';
  /*const isActive = (path) => {
    // For account/profile, check if the current path starts with /user-profile
    if (path === '/user-profile') {
      return location.pathname.startsWith('/user-profile') ? sidebarStyle.active : '';
    }
    return location.pathname === path ? sidebarStyle.active : '';
  }; */

  const isActive = (path) => {
    // Profile pages
    if (path === '/user-profile') {
      return location.pathname.startsWith('/user-profile')
        ? sidebarStyle.active
        : '';
    }

    // Full event pages (dynamic id)
    if (path === '/FullEventPage') {
      return location.pathname.startsWith('/FullEventPage')
        ? sidebarStyle.active
        : '';
    }

    // Coordinator dashboard OR FullEventPage (dynamic)
    if (path === '/coordinator-dashboard') {
      return location.pathname === '/coordinator-dashboard' ||
        location.pathname.startsWith('/FullEventPage')
        ? sidebarStyle.active
        : '';
    }

    // Default exact match
    return location.pathname === path ? sidebarStyle.active : '';
  };


  const handleLogout = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of your account.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Logout',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      reverseButtons: true
    });

    if (result.isConfirmed) {
      dispatch(logoutCoordinator());

      localStorage.clear();
      sessionStorage.clear();
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('coordinatorToken');

      navigate('/general-login');
    }
  };


  /*const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logoutCoordinator());
    localStorage.clear();
    sessionStorage.clear();
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('coordinatorToken');
    navigate('/general-login');
  };*/

  const cordinator_id = localStorage.getItem('cordinator_id');
  return (
    <>
      <div className={`${sidebarStyle.leftbar} mb-3`}>
        <div className={sidebarStyle.leftbarhead}>
          <div className={sidebarStyle.userimage}>
            <img
              src={coordinator.pic ? `${BASE_URL}${coordinator.pic}` : profile}
              alt="Profile"
            />
          </div>
          <div className={sidebarStyle.userdetails}>
            <p className={sidebarStyle.title}>{coordinator.fName} {coordinator.lName} </p>
            <p className={sidebarStyle.name}>{coordinator.position}</p>
          </div>
        </div>
        <div className={sidebarStyle.nav}>
          <div className={sidebarStyle.menu}>
            <ul>
              { /*<li className={`${isActive('/dashboard')}`}> */}
              <li className={`${isActive('/coordinator-dashboard')}`}>
                <Link to="/coordinator-dashboard" element={<DashboardPage />}>
                  <MdDashboard className={sidebarStyle.leftbaricon} />
                  <span className="text">Dashboard </span>
                </Link>
              </li>
              <li className={`${isActive('/add-event')}`}>
                <Link to="/add-event" element={<AddEventPage />}>
                  <BsFillPlusCircleFill className={sidebarStyle.leftbaricon} />
                  <span className="text">Add an Event</span>
                </Link>
              </li>
              { /* <li className={isActive('/coordinator-dashboard')}>
              <Link to="/coordinator-dashboard" element={<CoordinatorDashboardPage />}>
                <FaHeart className={sidebarStyle.leftbaricon} />
                <span className="text">Favorites</span>
              </Link>
            </li>
            <li>
              <Link to="">
                <IoIosPaper className={sidebarStyle.leftbaricon} />
                <span className="text">Reports</span>
              </Link>
            </li>
            <li>
              <Link to="">
                <HiSpeakerWave className={sidebarStyle.leftbaricon} />
                <span className="text">Promotional</span>
              </Link>
            </li>  
            <li>
              <Link to="">
                <IoBook className={sidebarStyle.leftbaricon} />
                <span className="text">Invite Author</span>
              </Link>
            </li>  */}
            </ul>
          </div>
          <div className={`${sidebarStyle.menu} mb-4`}>
            <ul>
              <li className={`${isActive('/user-profile')}`}>
                <Link to={`/user-profile/${cordinator_id}`} element={<UserProfilePage />}>
                  <ImUser className={sidebarStyle.leftbaricon} />
                  <span className="text">Account</span>
                </Link>
              </li>
              <li className={`${isActive('/coordinator-logout')}`}>
                <Link to="#" onClick={handleLogout}>
                  <BiLogOut className={sidebarStyle.leftbaricon} />
                  <span className="text">Log Out</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
